import { defineStore } from "pinia";
import Crud from "@/store/NewsFeed/crud";
import axios from "axios";

import { useLK } from "@/controllerLK/LKstore";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import {useNotificationsStore} from "@/store/notifications";
import { t } from "@/controllerLK/AvalLocalization";
import {areArraysEqual, convertIdsToString} from "@/functions/basic";
import { useThemesStore } from "@/store/NewsFeed/themes";
import { projectsApi } from "@/composables/api/projects.api";

const crud = new Crud(
    process.env.VUE_APP_BASE_API + "Rubrics/",
    "id",
    "",
    {}
);

export const useRubricsStore = defineStore({
  id: "rubrics",
  state: () => ({
    ...crud.state,
    formItems: [
      {
        condition: "AND",
        inputValue: "",
        id: Date.now()
      }
    ],

    // TODO: Разобраться для чего здесь дублируются переменные из themesStore.
    allThemes: [],
    chosenThemes: [],
    currentTheme: null,
    currentEditTheme: null,
    //

    allRubrics: [],
    chosenRubrics: [],
    currentRubric: null,
    currentEditRubric: {query: ""},

    disabledButton: true,
    currentCardRubrics: [],
    rubricLoader: false,
    rubricsOnMonitoring: [],

    //
    pulseCards: []
  }),
  getters: {
    ...crud.getters,
  },
  actions: {
    ...crud.actions,
    // Функция проверки, находится ли активная рубрика на мониторинге
    isCurrentRubricFixed() {
      if (this.chosenRubrics.length === 1) {
        const foundRubric = this.allRubrics.find((rubric) => rubric.id === this.chosenRubrics[0]);
        return foundRubric?.is_tracked ?? false;
      } else {
        return true;
      }
    },
    // Функция проверки. Выбраны ли все рубрики в зависимости от выбранных тем.
    isAllRubricsChosen () {
      const themesStore = useThemesStore();

      // Если выбраны темы, то проверяем по рубрикам в темам
      if (themesStore.chosenThemes.length > 0) {
        return areArraysEqual([...this.chosenRubrics], themesStore.allRubricsInThemes());
      }
      // Если тема не выбрана, проверяем по всем рубрикам на мониторинге
      else {
        if (this.chosenRubrics.length !== this.rubricsOnMonitoring.length) {
          return false;
        }
        const sortedArray1 = [...this.chosenRubrics].sort();
        const sortedArray2 = [...this.rubricsOnMonitoring].sort();
        return sortedArray1.every((item, index) => item === sortedArray2[index]);
      }
    },

    // Получение всех рубрик по проекту.
    async getAllRubrics() {
      const LKStore = useLK();
      if (!LKStore.project.id) return;

      try {
        const raw = await projectsApi.listRubrics(LKStore.project.id);

        // TODO: Удалить функцию и все места где используется, после изменения айдишников на беке. task 1873.
        const data = convertIdsToString(raw);
        //
        this.items = [];

        this.rubricsOnMonitoring = data.filter((rubric) => rubric.is_tracked).map((fixedRubrid) => fixedRubrid.id);

        const notificationStore = useNotificationsStore();
        if (!this.rubricsOnMonitoring.length && window.location.pathname === "/news") {
          notificationStore.createNotify(t("notification_item.error.no_rubric"), "error");
        }

        const event = new CustomEvent("ChangeRubrics");
        window.dispatchEvent(event);
        this.items = data;
        this.allRubrics = data;
        localStorage.setItem("allRubrics", JSON.stringify(data));
        return data;
      }  catch (e) {
        console.log(e);
        this.allRubrics = [];
        return [];
      }
    },

    // Функция создания новой рубрики
    async addNewRubric(rubric) {
      const LKStore = useLK();
      const notificationStore = useNotificationsStore();

      rubric.projectId = LKStore.project.id;

      try {
        const data = await projectsApi.createRubric(LKStore.project.id, rubric);
        notificationStore.createNotify(t("toast.changes_saved"), "success");
        await this.getAllRubrics();
        // TODO: task 1873/1900. Удалить после изменения id на беке.
        if (data?.id != null) data.id = data.id.toString();
        //
        return data;
      } catch (err) {
        this.rubricLoader = false;
        this.setError(err);
        return err;
      }
    },

    // Функция удаления существующий рубрики.
    async delRubric(rubricId) {
      const newsFeedStore = useNewsFeedStore();
      const LKStore = useLK();
      try {
        await projectsApi.removeRubric(LKStore.project.id, rubricId);
        this.chosenRubrics = [];
        this.currentRubric = this.items[0];
        await this.getAllRubrics();
        await newsFeedStore.getNews();
      } catch (err) {
        this.setError(err);
      }
    },

    // Функция сохранения изменений в рубрики
    async saveChanges(rubric) {
      const LKStore = useLK();
      const notificationStore = useNotificationsStore();
      this.rubricLoader = true;

      try {
        const data = await projectsApi.updateRubric(LKStore.project.id, rubric.id, rubric);
        await this.getAllRubrics();
        this.rubricLoader = false;
        notificationStore.createNotify(t("news_page_rubrics_edit_popup.message.saved_changes", rubric.name), "success");
        return data;
      } catch (error) {
        this.rubricLoader = false;
        this.setError(error);
        return error;
      }
    },

    // Функция подсветки найденных слов для проверки запроса lucene.
    async onHighLight(query, text) {
      console.log(query, text);
      const LKStore = useLK();
      const url = process.env.VUE_APP_BASE_API + `projects/${LKStore.project.id}/rubrics/highlight`;
      try {
        const res = await axios.post(url, {"query": query, "text": text});
        return res.data;
      } catch (err) {
        this.setError(err);
      }
    },

    // Функция исправление запроса lucene
    async luceneExpressionFix(user_request) {
      const url = "/news-story/api/LuceneExpressionFix/ollama/generate";
      try {
        const res = await axios.post(url, {"user_request": user_request});
        return res.data;
      } catch (e) {
        this.setError(e);
      }
    }

  },
});
